import { c as _c } from "react/compiler-runtime";
import getEnvValue from 'commons/getEnvValue';
import { getDefaultSelectedOptions } from 'components/consumer/PDP/helpers/pdpOptionUtils';
import useFlashSaleList from 'hooks/useFlashSaleList';
import { useMemo } from 'react';

// Get default values for options, in extended selected options format
const usePDPDefaultOptionValues = t0 => {
  const $ = _c(15);
  const {
    id,
    productOptions
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = getEnvValue("JB_UNIT_TEST_ENV");
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const isUnitTestEnv = t1 === "jest";
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      skip: isUnitTestEnv
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const {
    products: flashSaleProducts,
    variations: flashSaleVariations
  } = useFlashSaleList(undefined, t2);
  let t3;
  bb0: {
    if (!productOptions) {
      t3 = null;
      break bb0;
    }
    let t4;
    if ($[2] !== flashSaleProducts || $[3] !== id) {
      t4 = !!flashSaleProducts?.length && flashSaleProducts.includes(id);
      $[2] = flashSaleProducts;
      $[3] = id;
      $[4] = t4;
    } else {
      t4 = $[4];
    }
    const isProductInFlashSale = t4;
    let t5;
    if ($[5] !== flashSaleVariations || $[6] !== id || $[7] !== isProductInFlashSale) {
      t5 = isProductInFlashSale ? flashSaleVariations[id] : {};
      $[5] = flashSaleVariations;
      $[6] = id;
      $[7] = isProductInFlashSale;
      $[8] = t5;
    } else {
      t5 = $[8];
    }
    const flashSaleVariation = t5;
    let t6;
    if ($[9] !== flashSaleVariation || $[10] !== productOptions) {
      t6 = getDefaultSelectedOptions(productOptions, null, flashSaleVariation);
      $[9] = flashSaleVariation;
      $[10] = productOptions;
      $[11] = t6;
    } else {
      t6 = $[11];
    }
    t3 = t6;
  }
  const defaultSelectedOptionsFull = t3;
  let t4;
  bb1: {
    if (defaultSelectedOptionsFull) {
      let t5;
      if ($[12] !== defaultSelectedOptionsFull || $[13] !== productOptions) {
        t5 = Object.keys(defaultSelectedOptionsFull).reduce((acc, optionId) => {
          const option = productOptions?.find(t6 => {
            const {
              id: oId
            } = t6;
            return +oId === +optionId;
          });
          acc[optionId] = {
            value: option ? option.values.find(t7 => {
              const {
                id: oId_0
              } = t7;
              return `${oId_0}` === `${defaultSelectedOptionsFull[optionId].id}`;
            }) : {}
          };
          return acc;
        }, {});
        $[12] = defaultSelectedOptionsFull;
        $[13] = productOptions;
        $[14] = t5;
      } else {
        t5 = $[14];
      }
      t4 = t5;
      break bb1;
    }
    t4 = null;
  }
  const defaultSelectedOptionsExtended = t4;
  return defaultSelectedOptionsExtended;
};
export default usePDPDefaultOptionValues;